module.exports = __webpack_public_path__ + "Tenant.281d6040aa8923f169cabbd923180b27.hashedasset.svg";